import React from "react";

const ContactForm = () => {
  return (
    <div className="contact-area overflow-hidden default-padding mt-5">
      <div className="container">
        <div className="row">
        <div className="site-heading text-center">
              <h2>Contact</h2>
            </div>
          {/* Contact Form */}
          <div className="col-lg-6 contact-form-box">
            <div className="content">
              <div className="heading mb-4">
                <h2>Need Help?</h2>
                <p>Reach out to the world’s most reliable IT services.</p>
              </div>
              <form className="wpcf7-form" onSubmit={(e) => e.preventDefault()}>
                <div className="row">
                  <div className="col-lg-6 mb-3">
                    <input
                      type="text"
                      name="your-name"
                      className="form-control"
                      placeholder="Name"
                      required
                    />
                  </div>
                  <div className="col-lg-6 mb-3">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email*"
                      required
                    />
                  </div>
                  <div className="col-lg-12 mb-3">
                    <input
                      type="tel"
                      name="phone"
                      className="form-control"
                      placeholder="Phone"
                    />
                  </div>
                  <div className="col-lg-12 mb-3">
                    <textarea
                      name="comments"
                      rows="3"
                      className="form-control"
                      placeholder="Please describe what you need. *"
                      required
                    ></textarea>
                  </div>
                  <div className="col-lg-12">
                    <button type="submit" className="btn btn-primary" id="submit">
                      Send
                    </button>
                  </div>
                  <div className="col-md-12 alert-notification mt-3">
                    <div id="message" className="alert-msg"></div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Contact Image */}
          <div className="col-lg-6 text-center">
            <img
              className="contact-img img-fluid mt-3"
              src="https://img.freepik.com/free-vector/flat-design-illustration-customer-support_23-2148887720.jpg?t=st=1745319991~exp=1745323591~hmac=b652cabd0152f5f8c5a2277eb8b6f94bcca5ac584d8c3484a36879452696e857&w=740"
              alt="Contact"
            />
          </div>
        </div>
      </div>
      <style jsx>{`
.contact-area .content .heading {
    margin-bottom: 30px;
}
.contact-area form input, .contact-area form textarea {
    border: none;
    box-shadow: inherit;
    padding: 15px;
    background: #fafafa;
}
.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
form input {
    min-height: 60px;
}
.contact-area form textarea {
    min-height: 150px;
}
.contact-area form button {
    background: #00a7ac;
    border: none;
    display: inline-block;
    color: #fff;
    font-weight: 600;
    padding: 15px 40px;
    border-radius: 5px;
    margin-bottom: -20px;
}
.contact-img{
    border-radius: 20px;
height: 500px;
width: 500px;
text-align: center;
}

`}</style>
    </div>
  );
};

export default ContactForm;
